export default "__VITE_ASSET__BGitW2Ub__"